function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.5 22.552h-3v2.98h3v-2.98z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 10l11.56 11.48a1.482 1.482 0 0 1 0 2.106 1.5 1.5 0 0 1-1.06.437 1.5 1.5 0 0 1-1.06-.437L29 23.15V30H11v-6.85l-.44.436a1.507 1.507 0 0 1-2.12 0 1.482 1.482 0 0 1 0-2.106L20 10zm-1.5 18.51h9v-6.85L20 14.213l-7.5 7.447v6.85h3v-5.958h3v5.959z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 10.636v1.726l-3 2.98v-4.706h3z",
  fill: "currentColor"
});

var SvgAudienceOwnership = function SvgAudienceOwnership(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudienceOwnership, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audience_ownership.07e5cf1f.svg";
export { ForwardRef as ReactComponent };